import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';
import { SMALL_MARGIN, MIDDLE_MARGIN, colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: 'relative',
    },
    container: {
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },
    headerWrapper: {
      maxWidth: 'calc(100% - 210px)',
      [theme.breakpoints.down('lg')]: {
        maxWidth: '100%',
      },
      '& .header-icon': {
        [theme.breakpoints.down('sm')]: {
          margin: '0 8px 0 -10px',
        },
      },
    },
    headerButton: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    cardTitle: {
      [theme.breakpoints.down('md')]: {
        marginBottom: SMALL_MARGIN,
        borderBottom: `1px solid ${fade(colorsPalette.white, 0.33)}`,
      },
      [theme.breakpoints.down('sm')]: {
        marginLeft: 24,
        marginRight: 24,
      },
    },
    titleWrap: {
      [theme.breakpoints.up('md')]: {
        maxWidth: 'calc(100% - 100px)',
      },
    },
    title: {
      [theme.breakpoints.down('md')]: {
        marginBottom: 0,
        border: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 24,
        paddingRight: 24,
        marginBottom: SMALL_MARGIN,
      },
    },
    textWrap: {
      [theme.breakpoints.down('md')]: {
        width: '100%',
        maxWidth: '100%',
        minWidth: '100%',
        marginBottom: MIDDLE_MARGIN,
      },
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 24,
        paddingRight: 24,
      },
    },
    tableWrap: {
      position: 'relative',
      width: 'calc(100% - 372px)',
      [theme.breakpoints.down('xl')]: {
        width: '100%',
      },
    },
    table: {
      marginBottom: MIDDLE_MARGIN,
    },
    button: {
      minWidth: 150,
      [theme.breakpoints.down('md')]: {
        marginLeft: 24,
      },
      [theme.breakpoints.down('xs')]: {
        margin: 20,
        width: 'calc(100% - 40px)',
      },
    },
    buttonMobile: {
      [theme.breakpoints.up('lg')]: {
        display: 'none',
      },
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    dialog: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:focus': {
        outline: 'none',
      },
    },
  }),
);

export default useStyles;
